import React from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { Heading, Icons } from '@sede-enterprise/shell-ds-react-framework';
import theme from 'styled-theming';
import Button from '../../UI/Button';

export const backgroundColor = theme('name', {
  light: '#fff',
  dark: 'rgb(41, 41, 41)',
});

const UnauthorizedContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${backgroundColor};
  height: 50vh;

  .button_container {
    display: flex;
    gap: 20px;
    margin: 50px;
  }
`;
interface UnauthorizedPropsI {
  message: string;
  backOption: boolean;
}
const Unauthorized: React.FC<UnauthorizedPropsI> = ({
  message = 'Sorry you are not authorized to access Genesis',
  backOption = false,
}) => {
  const { AlertSolid: AlertSolidIcon, ArrowLeft } = Icons;
  const navigate = useNavigate();

  const handleBackOnClick = () => {
    navigate(-1);
  };

  return (
    <UnauthorizedContainer>
      <div>
        <AlertSolidIcon width={80} height={80} />
      </div>
      <Heading type='h1'>{message}</Heading>
      {backOption && (
        <div className='button_container'>
          <Button onClick={handleBackOnClick} icon={<ArrowLeft />}>
            Go Back
          </Button>
        </div>
      )}
    </UnauthorizedContainer>
  );
};

export default Unauthorized;
